<template>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Womi Recrute</h1>
    </div>
    <div class="container d-flex justify-content-between  mb-5 ">
      <button type="button" class="btn btn-add" v-on:click="AddAction">Add Post</button>
    </div>
    <div v-if="!addPost && !showUpdateForm" class=" container d-flex justify-content-between flex-wrap" >
      <PostCard :key="index" v-for=" (post , index) in this.posts " :post=post  @update="updateAction"  @refresh="getData" />
    </div>


    <AddPost v-if="addPost"  @refresh="getData"  @cancel="getData" />
    <UpdatePost v-if="showUpdateForm"  :post="this.toUpdate" @cancel="updateAction" @refresh="getData" />

</template>

<script>
import axios from 'axios'
import APIs from "@/../config";
import AddPost from './components/wrecrute/AddPost.vue';
import PostCard from './components/wrecrute/PostCard.vue'
import UpdatePost from './components/wrecrute/UpdatePost.vue';

export default {
    name: "Recrute",
    data() {
        return {
            addPost : false , 
            posts : [] , 
            toUpdate : {} , 
            showUpdateForm : false
        };
    },
    created() {
        this.getData()
    },
    methods: {
        getData(){
          axios.get(`${APIs.API_URL}/job/`)
          .then(res => {
            this.posts = res.data
            console.log(res.data)
          }).catch(error => {
              console.error(error)
          })
          this.addPost= this.showUpdateForm =  false
        },
        AddAction(){
            this.addPost = !this.addPost
        },
        updateAction(post){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = post
        },
    },
    components: { AddPost  , PostCard , UpdatePost}
}

</script>

<style scoped>



</style>


